<template src="./paladin-distribution-lists.html"></template>

<script>
import {
  ChiRhosV3,
 } from '@paladin/core'

//  import PaladinLimit from '../../../library/components/limit/paladin-limit'
  import { PaladinLimit, } from '@paladin/core-components'

import _ from 'lodash'

const ChiRhosV3Api = new ChiRhosV3().api();

export default {
  components: { PaladinLimit, },
  props: {
    allRoles: {
      type: Array,
      required: true,
    },
    groupEntityId: {
     type: String,
     required: true
    },
    eventTypes: {
     type: Array,
     default: null
    },
  },
  data() {
    return {
      lists: [],
      selected: null,
      current: {
        name: null,
        limit: null,
        belongsTo: this.groupEntityId,
      },
      members: [],
      membersTotal: 0,
      memberPage: 1,
      tabIndex: 0,
      currentLimitClone: null, // need to clone as otherwise we set up a loop!
      fields:{
        genderType: false,
        title: false,
        firstName: true,
        middleName: false,
        lastName: true,
        alternativeLastName: false,
        mobilePhone: false,
        alternativePhone: false,
        email: false,
        alternativeEmail: false,
        dateOfBirth: false,
        maritalStatus: false,
        isHidden: false,
        isDetailInDirectory: false,
        address: false,
        communicationSettings: false,
      },
      properties: false,
      memberships: false,
      shortMessage: null,
      subject: null,
      bodyHtml: null,
      bodyText: null,
      isNotification: true,
      sendSms: false,
      fieldsToShow: [],
      groupCache: [],
    }
  },
  computed: {
     listOptions: function (){
      return this.lists.map(item => {
        return {
          value: item.entity.entityId,
          text: item.entity.name
        };
      });
    },
  },
  watch: {
  },
   created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {
       ChiRhosV3Api.GroupApi.apiGroupDistributionListListPost({ apiEntityRequest: { entityId: this.groupEntityId } }).then(
            response => {
              if(response.data)
              {
                this.lists = response.data
              }
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )
    },
    resetForm()
    {
      this.current = {
        name: null,
        limit: null,
        belongsTo: this.groupEntityId,
      }

      this.currentLimitClone = null

      this.fields.genderType = false
      this.fields.title = false
      this.fields.firstName = true
      this.fields.middleName = false
      this.fields.lastName = true
      this.fields.alternativeLastName = false
      this.fields.mobilePhone = false
      this.fields.alternativePhone = false
      this.fields.email = false
      this.fields.alternativeEmail = false
      this.fields.dateOfBirth = false
      this.fields.maritalStatus = false
      this.fields.isHidden = false
      this.fields.isDetailInDirectory = false
      this.fields.address = false
      this.fields.communicationSettings = false
      this.properties = false
      this.memberships = false

      this.tabIndex = 0
      this.members = []
      this.memberTotal = 0
      this.memberPage = 1

      this.shortMessage = null
      this.subject = null
      this.bodyHtml = null
      this.bodyText = null
      this.isNotification = true
      this.sendSms = false
    },
    selectList()
    {
      this.resetForm()

      if(this.selected)
      {
          var item = this.lists.find(op => {
          return op.entity.entityId === this.selected
        });

        if(item)
        {
          this.current = item.entity
          this.currentLimitClone = _.clone(item.entity.limit, true)
          if(item.entity.properties && item.entity.properties.fields)
          {
            var split = item.entity.properties.fields.split(',')
            if(split.includes('genderType')) this.fields.genderType = true
            if(split.includes('title')) this.fields.title = true
            if(split.includes('firstName')) this.fields.firstName = true
            if(split.includes('middleName')) this.fields.middleName = true
            if(split.includes('lastName')) this.fields.lastName = true
            if(split.includes('alternativeLastName')) this.fields.alternativeLastName = true
            if(split.includes('mobilePhone')) this.fields.mobilePhone = true
            if(split.includes('alternativePhone')) this.fields.alternativePhone = true
            if(split.includes('email')) this.fields.email = true
            if(split.includes('alternativeEmail')) this.fields.alternativeEmail = true
            if(split.includes('dateOfBirth')) this.fields.dateOfBirth = true
            if(split.includes('maritalStatus')) this.fields.maritalStatus = true
            if(split.includes('isHidden')) this.fields.isHidden = true
            if(split.includes('isDetailInDirectory')) this.fields.isDetailInDirectory = true
            if(split.includes('address')) this.fields.address = true
            if(split.includes('communicationSettings')) this.fields.communicationSettings = true
            if(split.includes('properties')) this.properties = true
            if(split.includes('memberships')) this.memberships = true
          }
        }
        else
        {
          this.$toast("Could not find list", "error")
        }
      }
    },
    setLimit(value)
    {
      this.current.limit = value
    },
    saveList(evt)
    {
       evt.preventDefault()

       if(!this.current.properties) this.current.properties = {}
       this.current.properties.fields = this.fieldsToSave(true).join(',')

       ChiRhosV3Api.GroupApi.apiGroupDistributionListPost({ distributionListConstruct: this.current }).then(
            response => {
              if(response.data)
              {
                this.resetForm()
                this.selected = response.data.entity.entityId
                this.current = response.data.entity
                this.currentLimitClone = _.clone(response.data.entity.limit, true)
                this.init()
                this.$toast("List saved", "success")
              }
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )

    },
    deleteList()
    {
      ChiRhosV3Api.GroupApi.apiGroupDistributionListDeleteEntityIdDelete({ entityId: this.selected }).then(
        response => {
          this.resetForm()
          this.selected = null
          this.init()
          this.$toast("List deleted", "success")
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    loadMembers(page)
    {
      if(page === 0)
      {
        page = 1
        this.memberPage = 1
      }

      this.tabIndex = 1

      // clear any properties fields

      this.fieldsToShow = this.fieldsToSave(false)

      let fieldsToShow = this.fieldsToShow
      let properties = this.properties
      let memberships = this.memberships

      if(this.memberships) this.fieldsToShow.push('Memberships')

      ChiRhosV3Api.GroupApi.apiGroupDistributionListMembersPost({ apiEntityPagedRequest: { entityId: this.selected, page: page, pageSize: 10, sort: { property: "entity.lastName" } } }).then(
        response => {
          if(response.data)
          {
            var groups = []

            this.members = response.data.map(function(e) {

              if(properties && e.entity.properties)
              {
                Object.keys(e.entity.properties).forEach(function(key)
                {
                  var check = 'Property: ' + key

                  if(!fieldsToShow.includes(check)) fieldsToShow.push(check)

                  e.entity[check] = e.entity.properties[key]
                })
              }

              if(memberships && e.entity.memberOfGroup)
              {
                e.entity.Memberships = 'loading...'

                groups = groups.concat(e.entity.memberOfGroup.map(o => o.entityId))
              }

              return e.entity
            })
            this.membersTotal = response.totalCount

            this.populateGroups(Array.from(new Set(groups)))
          }
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    populateGroups(groups)
    {
      if(groups)
      {
        var missing = groups.filter(o => !this.groupCache[o])

        if(missing.length > 0)
        {
          var index = 0

          let groupCache = this.groupCache
          let populateMemberships = this.populateMemberships

          while(index < missing.length)
          {
            ChiRhosV3Api.GroupApi.apiGroupGetMultiplePost({ apiEntityMultipleRequest: { entityIds: missing.slice(index, index + 50) } }).then(
              response => {
                if(response.data)
                {
                  response.data.forEach(function(e) {
                    groupCache[e.entity.entityId] = e.entity
                  })

                  populateMemberships()
                }
              },
              error => {
                console.error(error)
                error.json().then(body => {
                  this.$toast(body.Message, "error")
                })
              }
            )

            index += 50
          }
        }
        else
        {
          this.populateMemberships()
        }
      }
    },
    populateMemberships()
    {
      if(this.members)
      {
        let allRoles = this.allRoles
        let groupCache = this.groupCache

        this.members.map(function(o) {
          if(o.memberOfGroup)
          {
            var memberships = ''

            o.memberOfGroup.forEach(function(mog) {
              if(mog.approvedAndActive && mog.accepted)
              {
                var role = allRoles.find(function(element) {
                  return element.value === mog.roleEntityId
                })

                if(role && groupCache[mog.entityId])
                {
                  if(memberships !== '') memberships += ' / '

                  memberships += role.text + ' @ ' + groupCache[mog.entityId].name
                }
              }
            })

            o.Memberships = memberships
          }
        })
      }
    },
    loadSettings()
    {
      this.tabIndex = 0
    },
    sendMessage(evt)
    {
      evt.preventDefault()

      ChiRhosV3Api.GroupApi.apiGroupDistributionListNotificationPost({ apiDistributionListNotificationRequest: {
          distributionListEntityId: this.selected,
          subject: this.subject,
          shortMessage: this.shortMessage,
          bodyHtml: this.bodyHtml,
          bodyText: this.bodyText,
          isNotification: this.isNotification,
          sendSms: this.sendSms,
        } }).then(
        response => {
          this.$toast("Message sent", "success")
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )

      // todo
    },
    fieldsToSave(includeExtended)
    {
      var fields = []

      if(this.fields.genderType) fields.push('genderType')
      if(this.fields.title) fields.push('title')
      if(this.fields.firstName) fields.push('firstName')
      if(this.fields.middleName) fields.push('middleName')
      if(this.fields.lastName) fields.push('lastName')
      if(this.fields.alternativeLastName) fields.push('alternativeLastName')
      if(this.fields.mobilePhone) fields.push('mobilePhone')
      if(this.fields.alternativePhone) fields.push('alternativePhone')
      if(this.fields.email) fields.push('email')
      if(this.fields.alternativeEmail) fields.push('alternativeEmail')
      if(this.fields.dateOfBirth) fields.push('dateOfBirth')
      if(this.fields.maritalStatus) fields.push('maritalStatus')
      if(this.fields.isHidden) fields.push('isHidden')
      if(this.fields.isDetailInDirectory) fields.push('isDetailInDirectory')
      if(this.fields.address) fields.push('address')
      if(this.fields.communicationSettings) fields.push('communicationSettings')
      if(includeExtended)
      {
        if(this.properties) fields.push('properties')
        if(this.memberships) fields.push('memberships')
      }

      return fields
    },
  }
}
</script>

<style lang="scss"></style>
